import { useCallback } from "react";
import { useParams } from "react-router-dom";

const useKlasisRouting = () => {
    const { locale } = useParams();

    const klasisRoute = useCallback(
        (route: string): string => {
            return `/${locale}/${route}`;
        },
        [locale]
    );

    return {
        klasisRoute
    }
}

export default useKlasisRouting;